import {ThemeProvider} from '@mui/material';
import theme from '../../theme';
import PaymentDetailsComponent from './PaymentDetailsComponent';

function PaymentDetailsContainer() {
  return (
    <ThemeProvider theme={theme}>
      <PaymentDetailsComponent />
    </ThemeProvider>
  );
}

export default PaymentDetailsContainer;
